import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import AntiTragusPiercingImage from '../../Assets/Piercing Services/anti tragus piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function AntiTragusPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Anti Tragus Piercing UAE | 250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Anti Tragus Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Anti Tragus Piercing 250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={AntiTragusPiercingImage} alt="Anti Tragus Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Anti Tragus Piercing</h3>

          <p>
            Make a bold and edgy style statement with our professional anti-tragus piercing services in the UAE, available at an affordable price of 250 AED. Anti-tragus piercing is a distinctive cartilage piercing placed on the small raised area opposite the tragus, just above the earlobe. This unique placement creates a striking and modern look that stands out from traditional ear piercings, making it a perfect choice for individuals who want to express their individuality with confidence. Whether you prefer a minimal stud or a small hoop, our expert specialists ensure precise placement for a balanced and visually appealing result that enhances your overall ear design.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each anti-tragus piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Due to its cartilage location, anti-tragus piercing requires expert handling, and our experienced specialists are trained to perform the procedure accurately while minimizing discomfort and ensuring proper alignment.
          </p>

          <p>
            Anti-tragus piercing is ideal for those who want a bold and unique ear style that adds character to their overall look. Its placement makes it a standout feature while still blending beautifully with other ear piercings such as helix, conch, tragus, or lobe, allowing you to create a curated and layered ear aesthetic. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your ear anatomy and personal style.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your anti-tragus piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your anti-tragus piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our anti-tragus piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted anti-tragus piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a bold and edgy ear look effortlessly. Book your anti-tragus piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Anti Tragus Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AntiTragusPiercing;